export default "__VITE_ASSET__CyrIvE$8__"